import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import devopsOne from "./assets/devops/devops_1.png";
import devopsTwo from "./assets/devops/devops_2.png";
import devopsThree from "./assets/devops/devops_3.png";
import devopsFour from "./assets/devops/devops_4.png";
import devopsFive from "./assets/devops/devops_5.png";

import hightRoi from "./assets/devops/high_roi.png";
import provenExp from "./assets/devops/proven_exp.png";
import scalability from "./assets/devops/Scalability.png";
import training from "./assets/android/training.png";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const DevopsServerTraining = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [devopsThree, devopsTwo, devopsFour, devopsFive];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${devopsOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              Backend and DevOps Training
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              Backend and DevOps Training
            </Typography>
            <Typography variant="body1" paragraph>
              Our Backend and DevOps training program is tailored to meet the
              evolving demands of modern software development. Backend
              development focuses on server-side logic, databases, APIs, and the
              integration of front-end elements, while DevOps ensures continuous
              integration and delivery, server automation, and infrastructure
              management. Combining both skill sets prepares you for highly
              sought-after roles in full-stack development, system architecture,
              and operations engineering.
            </Typography>

            <Typography variant="body1" paragraph>
              We provide a hands-on, project-based learning experience that
              simulates real-world development environments. You will learn to
              build scalable backend systems using Node.js, Python, or Java, and
              integrate them with CI/CD pipelines, Docker containers, and cloud
              platforms like AWS or Azure. Whether you're a beginner or an
              upskilling professional, this training equips you with the
              knowledge and confidence to succeed in tech teams across any
              industry. In addition to technical training, our program also
              emphasizes industry best practices such as writing clean,
              maintainable code, managing version control using Git,
              implementing secure authentication mechanisms, and ensuring high
              system availability. You’ll also learn how to monitor performance
              metrics, troubleshoot live issues, and automate deployment
              workflows—skills that are critical for maintaining efficient and
              reliable applications in production environments. What sets our
              training apart is our mentorship-driven approach and real-time
              problem-solving sessions. You’ll work directly with seasoned
              backend and DevOps professionals who bring years of industry
              experience. Regular code reviews, mock interviews, and
              portfolio-building exercises ensure you're not just job-ready, but
              career-ready. By the end of the program, you’ll be equipped to
              contribute effectively to complex development and operations
              projects in any enterprise or startup setting.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              What is Server Development and DevOps?
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Server development involves creating and managing the backend
              components of an application, including APIs, database queries,
              server logic, and authentication systems. This layer is
              responsible for handling data processing, business logic, and
              system integration that powers the application behind the scenes.
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              DevOps is the practice of unifying software development (Dev) and
              IT operations (Ops). It emphasizes automation, continuous
              delivery, and infrastructure-as-code to enhance software
              deployment and performance. DevOps helps streamline workflows,
              reduce downtime, and increase reliability — making it essential
              for agile development teams. system integration that powers the
              application behind the scenes.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={hightRoi}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Why Should You Learn Server Development?
            </Typography>
            <Typography variant="body1">
              The backend is the backbone of any digital application. Without a
              strong server-side infrastructure, apps would fail to deliver
              fast, secure, and seamless user experiences. Learning server
              development opens doors to countless opportunities in web, mobile,
              and enterprise software environments. As data and systems become
              more complex, companies are in dire need of developers who can
              architect scalable and secure server-side solutions. By learning
              backend development, you become a critical part of the product
              lifecycle — from database design to API integration and beyond.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Why Learn Server Development and DevOps Training From Us?
            </Typography>
            <Typography variant="body1">
              We provide a highly structured training path taught by industry
              veterans who bring real-time experience to the classroom. Our
              teaching methodology is project-based, ensuring you don’t just
              learn theory, but also apply it through practical assignments and
              real development scenarios. What sets us apart is our dual focus:
              while you master backend technologies like REST APIs, databases,
              and authentication systems, you’ll also gain hands-on experience
              with tools like Docker, Kubernetes, Jenkins, and GitOps. This
              hybrid skill set gives you a competitive edge in the job market
              and prepares you for roles that require both development and
              operations expertise.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={scalability}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={devopsFour}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Zero Investment Training
            </Typography>
            <Typography variant="body1">
              Our zero-investment model allows you to enroll without any upfront
              fees. We believe in performance-based success — you only pay once
              you're placed in a full-time job. This ensures we stay motivated
              to deliver high-quality training that leads to real employment
              outcomes. Our goal is to remove financial barriers for aspiring
              tech professionals. Whether you’re a student or someone looking to
              switch careers, our zero-investment structure makes it easier to
              pursue high-demand backend and DevOps skills without taking on
              financial risk.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Comprehensive Training
            </Typography>
            <Typography variant="body1">
              Our curriculum is designed to cover every crucial area in backend
              and DevOps. From data modeling and API creation to container
              orchestration and CI/CD pipelines, we make sure no topic is left
              untouched. You’ll also explore real-world deployment practices and
              cloud integration strategies. In addition to technical skills, we
              also focus on soft skills like team collaboration,
              problem-solving, and code documentation — essentials for a
              professional work environment. Our comprehensive approach ensures
              that when you complete the course, you’re not just trained —
              you're industry-ready.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={provenExp}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={training}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Highly Qualified Training Team
            </Typography>
            <Typography variant="body1">
              Our instructors are professionals with years of experience in
              backend development, DevOps engineering, and IT consulting. They
              bring deep knowledge and up-to-date practices to each session,
              ensuring you're learning what employers actually need. More than
              just teachers, our team acts as mentors. They guide you through
              challenges, help you refine your code, and support you in mock
              interviews and resume building. Their practical insights help
              bridge the gap between training and industry expectations.
            </Typography>

            <Typography variant="body1" sx={{ mt: 1 }}>
              We provide a fully equipped in-house training lab with real-time
              servers, development tools, and simulation environments. Whether
              it's deploying a server, configuring a CI/CD pipeline, or
              troubleshooting live issues, you’ll get hands-on experience in a
              safe and supportive setting. Our labs mimic real company
              environments, allowing you to work on full-fledged projects with
              team collaboration tools and version control systems. This ensures
              you're prepared to contribute effectively from day one of your
              job.
            </Typography>

            <Typography variant="body1" sx={{ mt: 1 }}>
              Upon completion of the training, we assist you in landing a
              full-time job with reputable tech companies. We offer resume
              support, job interview coaching, and connect you with our network
              of hiring partners. Our track record in placement speaks for
              itself — many of our graduates secure positions as backend
              developers, DevOps engineers, site reliability engineers, and
              system administrators. With our end-to-end support, you don’t just
              learn — you launch your career.
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default DevopsServerTraining;
